export default __webpack_public_path__ + "static/media/amaze-9.be4493a1.jpg";